// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:48:36.077Z
// Property: Dakota Apartments (ID: 6767906449167197)
// Collections: 16 amenities, 2 floorplans (live), 11 photos, 58 POIs, 4 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167197",
  "property_external_id": "1139492",
  "property_zillow_url": "https://www.zillow.com/apartments/stanley-nd/dakota-apartments/5hDskd/",
  "property_apartments_url": "https://www.apartments.com/dakota-apartments-stanley-nd/dv8641j/",
  "property_google_business_url": "https://www.google.com/maps/place/Dakota+A/data=!4m2!3m1!1s0x0:0xb4b986529495f269?sa=X&ved=2ahUKEwiyr4CO-IOTAxUyZ0EAHbkqI_sQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "dakota-a",
  "property_name": "Dakota Apartments",
  "property_website_url": "https://www.dakotaaapts.com",
  "property_domain": "https://www.dakotaaapts.com",
  "property_address": "101 8th Ave SW",
  "property_full_address": "101 8th Ave SW, Stanley, ND 58784",
  "property_address_1": "101 8th Ave SW",
  "property_address_2": null,
  "property_address_city": "Stanley",
  "property_address_state": "ND",
  "property_address_zip_full": "58784",
  "property_address_zip": "58784",
  "property_address_country": "US",
  "property_address_county": "Mountrail County",
  "property_neighborhood_address": null,
  "property_address_latitude": "48.3106564",
  "property_address_longitude": "-102.3921812",
  "property_email": "dakotaa@weidner.com",
  "property_phone": "7018001663",
  "property_call_tracking_phone": "701-712-5691",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Dakota A in Stanley, ND, embrace a lifestyle of comfort with spacious two-bedroom apartments featuring stunning courtyard views. Enjoy amenities like private entrances, walk-in closets, and modern kitchens. With 24-hour maintenance and smoke-free living, your perfect home awaits. Ready to make the move? Discover your new sanctuary today!",
  "property_long_description": "**Discover Your New Home at Dakota A in Stanley, ND!**\n\nWelcome to Dakota A, where modern living meets comfort and convenience in the heart of Stanley, ND! Our beautifully designed two-bedroom apartments offer everything you need for a perfect home. With stunning courtyard views, you'll love unwinding on your patio or balcony after a long day.\n\nOur apartment community boasts exceptional amenities tailored for your lifestyle. Enjoy the peace of mind provided by our 24-hour emergency maintenance and professional management team, ensuring your living experience is smooth and hassle-free. Open guest parking and on-site maintenance means convenience is at your fingertips.\n\nStep inside your spacious apartment, complete with a fully equipped kitchen, plush carpet, and large walk-in closets, providing you ample storage space. Each unit features central heating and air conditioning, as well as window coverings that let you control your natural light. Plus, you’ll appreciate the convenience of an in-unit washer and dryer, making laundry days a breeze.\n\nAt Dakota A, we pride ourselves on a smoke-free environment that promotes a healthy lifestyle. The heated common area hallways add a touch of comfort during colder months, while our inviting community atmosphere makes it easy to meet neighbors and create lasting connections.\n\nReady to elevate your living experience? Find your new home today by browsing our availability or scheduling a tour to visit Dakota A. Embrace a lifestyle of comfort, community, and connection—your dream apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-3e35-726a-a3f6-c07cb9e906d3.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living room with a sectional sofa, coffee table, and floor lamp.",
    "public_id": "019d0220-3e35-726a-a3f6-c07cb9e906d3",
    "storage_key": "property/6767906449167197/019d0220-3e35-726a-a3f6-c07cb9e906d3.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "38",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://dakotaaapts.securecafe.com/onlineleasing/dakota-a/floorplans.aspx",
  "property_resident_portal_url": "https://dakotaaapts.securecafenet.com/residentservices/dakota-a/userlogin",
  "property_apply_now_url": "https://dakotaaapts.securecafe.com/onlineleasing/dakota-a/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14140-65a0-7579-9558-6727b836f960.webp",
  "property_primary_logo_media": {
    "alt_text": "Dakota Apartments logo",
    "public_id": "01a14140-65a0-7579-9558-6727b836f960",
    "storage_key": "property/6767906449167197/01a14140-65a0-7579-9558-6727b836f960.webp",
    "width": 106,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14140-b18e-77fe-b868-13f6ab7f5faa.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Location pin icon",
    "public_id": "01a14140-b18e-77fe-b868-13f6ab7f5faa",
    "storage_key": "property/6767906449167197/01a14140-b18e-77fe-b868-13f6ab7f5faa.webp",
    "width": 106,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14140-a6ba-74b4-960a-d92d047b0758.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Location pin icon",
    "public_id": "01a14140-a6ba-74b4-960a-d92d047b0758",
    "storage_key": "property/6767906449167197/01a14140-a6ba-74b4-960a-d92d047b0758.webp",
    "width": 106,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#23493E",
  "property_secondary_color": "#CFDBED",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#51828D",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1102 - 1102",
  "property_sqft_min": "1102",
  "property_sqft_max": "1102",
  "property_price_range": "1050 - 1125",
  "property_price_min": "1050",
  "property_price_max": "1125",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/DakotaApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJscYJZsC8IFMRafKVlFKGubQ",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Dakota A",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Community Home",
  "property_home_amenities_blurb": "Welcome to Dakota A in Stanley, ND, where comfort meets style! Enjoy spacious two-bedroom apartments featuring private entries, fully equipped kitchens, and beautiful courtyard views. Benefit from plush carpets, walk-in closets, and 24-hour maintenance—all within our smoke-free community. Elevate your living experience today and enjoy every moment at Dakota A!",
  "property_home_floorplans_blurb": "Welcome to Dakota A in Stanley, ND, where modern living meets comfort. With thoughtfully designed floor plans tailored to your lifestyle, each apartment combines style and functionality. Browse our available homes today to find the perfect layout that suits your needs and elevates your living experience.",
  "property_home_gallery_blurb": "At Dakota A in Stanley, ND, life unfolds beautifully with spacious two-bedroom apartments featuring serene courtyard views, modern amenities, and private entries. Enjoy the comfort of heated hallways, in-unit washers and dryers, and generous walk-in closets. Picture yourself living here and embrace a smoke-free, maintenance-free lifestyle. ",
  "property_home_neighborhood_blurb": "At Dakota A in Stanley, ND, enjoy a vibrant lifestyle surrounded by local treasures. From the serene Stanley Public Library to the invigorating Boom Fitness and scenic Prairie Rose Golf Course, our community offers enriching experiences just steps away. Embrace the charm of nearby parks and explore our delightful neighborhood!",
  "property_home_reviews_blurb": "At Dakota A in Stanley, ND, our residents rave about the warmth of our community. One resident shares, “It's a fantastic place to call home—with friendly neighbors and excellent management.” Experience that welcoming spirit for yourself and see what our residents have to say about living here!",
  "property_neighborhood_blurb": "Nestled in the heart of Stanley, ND, Dakota A offers two-bedroom floor plans surrounded by vibrant local attractions. Enjoy the tranquility of Stanley Park and the convenience of nearby amenities like the Stanley Public Library and Boom Fitness. Embrace a lifestyle enriched by community and nature—see what's around us today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Dakota A in Stanley, ND, two-bedroom apartments redefine comfort with stunning courtyard views, spacious walk-in closets, and private entries. Enjoy 24-hour emergency maintenance, a fully equipped kitchen, and charming patios or balconies, all in a smoke-free environment. Experience a home where convenience meets tranquility—see what awaits!",
  "property_applynow_blurb": "At Dakota A in Stanley, ND, our two-bedroom apartments blend comfort with convenience. Enjoy beautiful courtyard views, spacious walk-in closets, and private entries. With 24-hour maintenance and smoke-free living, your ideal lifestyle awaits. Ready to elevate your living experience? Find your new home and lease online today!",
  "property_contactus_blurb": "At Dakota A in Stanley, ND, our inviting two-bedroom floor plans offer the perfect blend of comfort and style. With thoughtfully designed spaces that elevate modern living, you’re bound to find your ideal home. Have questions? Contact our leasing team today for personalized assistance and to view all our options!",
  "property_faqs_blurb": "At Dakota A in Stanley, ND, our thoughtfully designed two-bedroom floor plans offer a perfect blend of comfort and style. Curious about life in our vibrant community? Dive into our FAQs page to uncover answers to your pressing questions and learn why Dakota A is your ideal home.",
  "property_floorplans_blurb": "At Dakota A in Stanley, ND, our thoughtfully designed two-bedroom apartments cater to your lifestyle. Experience spacious living with layouts that embrace comfort and style. Check out the variety of floor plans we offer and find the home that resonates with you—your ideal living space awaits!",
  "property_gallery_blurb": "At Dakota A in Stanley, ND, experience life in a serene community with breathtaking courtyard views and spacious two-bedroom floor plans. Enjoy the comforts of home with private entries, plush carpets, and fully equipped kitchens. Picture yourself living here—where convenience meets tranquility in every detail!",
  "property_interactivemap_blurb": "At Dakota A in Stanley, ND, our two-bedroom apartments offer unparalleled comfort with beautiful courtyard views, spacious walk-in closets, and private entries. Enjoy a smoke-free environment with modern amenities like a fully equipped kitchen, washer and dryer, and 24-hour maintenance. Use our interactive community map to find your new home!",
  "property_pets_blurb": "At Dakota A in Stanley, ND, your four-legged family members are embraced with open arms! We offer a pet-friendly haven with ample space for both play and relaxation, featuring a modest pet fee and deposit. Enjoy life's moments together—where comfortable living meets the joy of pet companionship.",
  "property_referafriend_blurb": "At Dakota A in Stanley, ND, our spacious two-bedroom floor plans offer a perfect blend of comfort and style. Share the joy of upscale living with friends—when you refer them to our community, everyone benefits. Great friends make great neighbors; invite someone to experience Dakota A today!",
  "property_residentaccess_blurb": "Welcome to Dakota A in Stanley, ND, where comfort meets style in our spacious two-bedroom apartments. Seamlessly manage your living experience through our resident portal—easily pay rent, schedule maintenance, and access exclusive community updates. Join us at Dakota A, where modern living is just a click away!",
  "property_reviews_blurb": "At Dakota A in Stanley, ND, our residents consistently rave about the welcoming atmosphere and exceptional amenities. One resident shares, “The sense of community here truly makes it feel like home.” See what our residents have to say about living at our community and experience the Dakota A lifestyle for yourself!",
  "property_created_at": "1771538592639",
  "property_scheduletour_blurb": "At Dakota A in Stanley, ND, our spacious two-bedroom apartments redefine comfort and style. With a variety of floor plans to suit your needs, you’ll find the perfect home. Curious about the experience? Schedule a tour and hear firsthand what our residents love about life in our vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out! At Dakota A in Stanley, ND, we offer spacious two-bedroom floor plans designed to fit your lifestyle. Stay tuned as a member of our friendly team will be in touch soon to assist you in finding your perfect home. Your journey to comfort starts here!",
  "property_virtualtours_blurb": "Welcome to Dakota A in Stanley, ND, where your dream two-bedroom apartment awaits. Experience spacious layouts and modern amenities that elevate your living. Don't just imagine your new home—take a virtual tour today and see firsthand why Dakota A is the perfect fit for your lifestyle!",
  "property_copyright": "2026 All Rights Reserved. Dakota A",
  "property_seo_title_home": "Find comfort - pet-friendly apartments in Stanley, ND",
  "property_seo_description_home": "Enjoy in-unit laundry, pet-friendly living, and free parking at Dakota Apartments in vibrant Stanley, ND.",
  "property_seo_title_floorplans": "Spacious floor plans - Dakota Apartments - Stanley, ND",
  "property_seo_description_floorplans": "Explore two-bedroom layouts at Dakota in Stanley, ND, with in-unit washer and dryer, open-concept designs, and generous storage.",
  "property_seo_title_amenities": "Quality amenities - Dakota Apartments - Stanley, ND",
  "property_seo_description_amenities": "Enjoy a pet-friendly community, in-unit laundry, and beautiful courtyard views at Dakota in Stanley, ND.",
  "property_seo_title_gallery": "Photos - Dakota Apartments - Stanley, ND",
  "property_seo_description_gallery": "Explore the Dakota photo gallery, see two-bedroom floor plans and gorgeous community spaces in Stanley, ND.",
  "property_seo_title_virtualtours": "Dakota Apartments virtual tour in Stanley, ND",
  "property_seo_description_virtualtours": "Explore Dakota in Stanley, ND from home. Take a virtual tour and imagine life, layouts, and atmosphere before you visit.",
  "property_seo_title_interactivemap": "Interactive Map | Dakota A Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Dakota A in Stanley, ND! Enjoy spacious two-bedroom apartments with stunning courtyard views. Check our interactive map now!",
  "property_seo_title_neighborhood": "Neighborhood near Dakota Apartments in Stanley, ND",
  "property_seo_description_neighborhood": "Live steps from Wilson Park, schools, and shopping at Dakota in Stanley, ND. Enjoy dining, local shops, and easy access to Highway 2.",
  "property_seo_title_contact": "Contact Dakota Apartments in Stanley, ND",
  "property_seo_description_contact": "Contact Dakota in Stanley, ND. Our leasing team is here to help you find your home and answer any questions.",
  "property_seo_title_faqs": "FAQs | Apartments in Stanley, ND",
  "property_seo_description_faqs": "Uncover the comforts of Dakota A in Stanley, ND. From spacious walk-in closets to stunning courtyard views, find answers on our FAQs page today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Stanley, ND",
  "property_seo_description_reviews": "At Dakota A in Stanley, ND, our residents love the spacious two-bedroom layouts and unbeatable amenities. Read their reviews and envision your new home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Stanley, ND",
  "property_seo_description_applynow": "Experience comfort at Dakota A in Stanley, ND! Enjoy spacious two-bedroom layouts, gorgeous courtyard views, and 24/7 maintenance. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Dakota A",
  "property_seo_description_residentaccess": "Easily manage your life at Dakota A, Stanley, ND. Use the resident portal for rent, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Dakota A",
  "property_seo_description_referafriend": "Refer a friend to Dakota A in Stanley, ND, and enjoy vibrant living with your besties. Great friends make great neighbors—spread the word today!",
  "property_seo_title_scheduletour": "Schedule a tour - Dakota Apartments - Stanley, ND",
  "property_seo_description_scheduletour": "Tour Dakota Apartments in Stanley, ND your way. Choose in-person or virtual options - find a time that works for you.",
  "property_seo_title_privacy": "Privacy Policy | Dakota A",
  "property_seo_description_privacy": "Your privacy matters at Dakota A. Delve into our policy to see how we protect your information while you enjoy life in beautiful Stanley, ND.",
  "property_seo_title_accessibility": "Website Accessibility | Dakota A",
  "property_seo_description_accessibility": "At Dakota A in Stanley, ND, we're dedicated to digital inclusion, ensuring every resident feels at home. Embrace comfort today!",
  "property_seo_title_sitemap": "Sitemap | Dakota A",
  "property_seo_description_sitemap": "Uncover every corner of Dakota A in Stanley, ND! Navigate our sitemap to find your perfect home and experience community living at its finest.",
  "property_seo_title_thankyou": "Thank You | Dakota A",
  "property_seo_description_thankyou": "Thank you for reaching out to Dakota A in Stanley, ND! Our team is on it and will connect with you soon to discuss your future home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Stanley, ND",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764161",
  "amenities": [
    {
      "id": "ec_acbeea323e52fab45b82da04",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646594",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8688f1753dd916b445be6c9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646606",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2b55b12f010f90ecbf4e320",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646607",
      "title": "Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d9a36-5c9e-77b7-a197-a90a3311e42a.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer unit",
        "public_id": "019d9a36-5c9e-77b7-a197-a90a3311e42a",
        "storage_key": "property/6767906449167197/019d9a36-5c9e-77b7-a197-a90a3311e42a.webp",
        "width": 600,
        "height": 442
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c807dcfec593ff175f0ac5eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646608",
      "title": "Plush Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_407f7d16f50ce2104b4df275",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646609",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e179a2363250bafa17f5f22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646610",
      "title": "Central Heating and Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94359824113aee268593e0e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646611",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e127d6fb8a1d5201576fe66e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646584",
      "title": "Beautiful Courtyard Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-4be4-7499-9216-3080678b0388.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a multi-unit apartment building with beige siding and brick accents, featuring balconies and walkways.",
        "public_id": "019d0220-4be4-7499-9216-3080678b0388",
        "storage_key": "property/6767906449167197/019d0220-4be4-7499-9216-3080678b0388.webp",
        "width": 2000,
        "height": 1473
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b1703e52a505d240c777e26",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646603",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-6a9b-746e-aad5-8006f7175e0b.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, white countertops, and a white refrigerator.",
        "public_id": "019d0220-6a9b-746e-aad5-8006f7175e0b",
        "storage_key": "property/6767906449167197/019d0220-6a9b-746e-aad5-8006f7175e0b.webp",
        "width": 600,
        "height": 442
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_390901507f2663bda4c446a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646585",
      "title": "Open Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f5f2dec2e5f431f9b9b232e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646604",
      "title": "Private Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52d1334d7ad184399a00b1e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646591",
      "title": "Heated Common Area Hallways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b1b81594a9dcbdd08bbd8c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646605",
      "title": "Spacious Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e556fdda53442ab1ce6b566",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646592",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dabad8e479362e12104d76da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "87646593",
      "title": "Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63d1472274d52d37beb91e17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "124800043",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ac9c9b31c64846ba0b3d73e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-3e35-726a-a3f6-c07cb9e906d3.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and floor lamp.",
        "public_id": "019d0220-3e35-726a-a3f6-c07cb9e906d3",
        "storage_key": "property/6767906449167197/019d0220-3e35-726a-a3f6-c07cb9e906d3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable and stylish living room, perfect for entertaining or quiet evenings at home.",
      "link": "false",
      "alt_text": "A bright, cozy living room here at Dakota featuring a light gray sectional sofa with neutral throw pillows, a wooden coffee table on a soft area rug, warm beige walls, indoor plants, simple wall art, and a floor lamp, creating a clean and inviting apartment living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Favorites%20(1).jpg"
    },
    {
      "id": "ec_4060bf51aa1e8c0813c464f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019f6994-da5d-763c-9965-00a5df8bd005.webp",
      "image_media": {
        "alt_text": "Call for July move-in specials graphic.",
        "public_id": "019f6994-da5d-763c-9965-00a5df8bd005",
        "storage_key": "property/6767906449167197/019f6994-da5d-763c-9965-00a5df8bd005.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Graphic announcing \"Call for July Move-In Specials\" with a disclaimer about limited time offer, restrictions, and availability subject to change.",
      "link": "false",
      "alt_text": "A sign advertising a limited time offer for move-in specials in July.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials%20(3230).png"
    },
    {
      "id": "ec_7e983f44b19024bba0911268",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-3e2f-71c8-a772-9851a5ad2565.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and laminate countertops.",
        "public_id": "019d0220-3e2f-71c8-a772-9851a5ad2565",
        "storage_key": "property/6767906449167197/019d0220-3e2f-71c8-a772-9851a5ad2565.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white appliances including a refrigerator, stove, and dishwasher, complemented by warm wood cabinetry and durable laminate countertops.",
      "link": "false",
      "alt_text": "A bright, functional kitchen here at Dakota featuring warm wood cabinetry, white appliances including a refrigerator, stove, and dishwasher, durable neutral countertops, vinyl flooring, and ample counter space that creates a clean and practical apartment cooking area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Favorites%20(2).jpg"
    },
    {
      "id": "ec_45d99ee4f1963ea5ca766ccf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-3f75-724f-aa24-c1b2c3b12a4a.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dining table, chairs, cabinets, refrigerator, stove, and washing machine.",
        "public_id": "019d0220-3f75-724f-aa24-c1b2c3b12a4a",
        "storage_key": "property/6767906449167197/019d0220-3f75-724f-aa24-c1b2c3b12a4a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A bright and spacious kitchen and dining area, perfect for everyday living and entertaining. Features ample cabinet space, a breakfast bar, and a convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "A spacious open-concept dining and kitchen area here at Dakota featuring warm wood cabinetry, a peninsula breakfast bar, white appliances, soft carpet transitioning to vinyl flooring, a four-seat dining table with modern chairs, and neutral lighting that creates a bright, welcoming apartment interior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Favorites%20(3).jpg"
    },
    {
      "id": "ec_9d26c10b57d9fc3d7688608c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019dd7e4-0058-730f-a2de-09c31908f01a.webp",
      "image_media": {
        "alt_text": "Hallway with doors to bathroom and closet.",
        "public_id": "019dd7e4-0058-730f-a2de-09c31908f01a",
        "storage_key": "property/6767906449167197/019dd7e4-0058-730f-a2de-09c31908f01a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a hallway connecting to a bathroom and a spacious closet with built-in shelving.",
      "link": "false",
      "alt_text": "A hallway with a mirror and a doorway leading to a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(7).jpg"
    },
    {
      "id": "ec_31da9df7f01b0137cc5dca91",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019dd7e4-00b0-77db-b81b-e48b86b1d3d4.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet.",
        "public_id": "019dd7e4-00b0-77db-b81b-e48b86b1d3d4",
        "storage_key": "property/6767906449167197/019dd7e4-00b0-77db-b81b-e48b86b1d3d4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days.",
      "link": "false",
      "alt_text": "Two white front loading washing machines in a laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(8).jpg"
    },
    {
      "id": "ec_067a1f0a6a54e478d9e8d1dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-4986-739c-abc9-59057aed4820.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, sink, mirror, and bathtub with shower curtain.",
        "public_id": "019d0220-4986-739c-abc9-59057aed4820",
        "storage_key": "property/6767906449167197/019d0220-4986-739c-abc9-59057aed4820.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a full bathroom featuring a toilet, vanity with sink, and a bathtub/shower combination with a decorative curtain.",
      "link": "false",
      "alt_text": "A bathroom with a toilet, sink, and shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(5).jpg"
    },
    {
      "id": "ec_00e3f6c0da870528a385f2c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-4ad1-72ed-8d53-82d90263e4a4.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with multiple shelves.",
        "public_id": "019d0220-4ad1-72ed-8d53-82d90263e4a4",
        "storage_key": "property/6767906449167197/019d0220-4ad1-72ed-8d53-82d90263e4a4.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving, perfect for storage.",
      "link": "false",
      "alt_text": "Empty shelves in a room with white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(6).jpg"
    },
    {
      "id": "ec_0ea897fa1c34fa95d8700e72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-3f36-755b-a6c1-c2ac4948332c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
        "public_id": "019d0220-3f36-755b-a6c1-c2ac4948332c",
        "storage_key": "property/6767906449167197/019d0220-3f36-755b-a6c1-c2ac4948332c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern nightstands with lamps, and ample closet space for storage.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and two lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(4).jpg"
    },
    {
      "id": "ec_ee9d8117944367ef4d57c766",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-4be4-7499-9216-3080678b0388.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-unit apartment building with beige siding and brick accents, featuring balconies and walkways.",
        "public_id": "019d0220-4be4-7499-9216-3080678b0388",
        "storage_key": "property/6767906449167197/019d0220-4be4-7499-9216-3080678b0388.webp",
        "width": 2000,
        "height": 1473
      },
      "title": "Community",
      "description": "Showcasing the exterior of our apartment community, highlighting the building's facade, walkways, and balconies.",
      "link": "false",
      "alt_text": "Apartment building with a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(9).jpg"
    },
    {
      "id": "ec_4463d6430337339baafa9992",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0220-549c-77cb-85c5-d4ec5528af96.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and grass area.",
        "public_id": "019d0220-549c-77cb-85c5-d4ec5528af96",
        "storage_key": "property/6767906449167197/019d0220-549c-77cb-85c5-d4ec5528af96.webp",
        "width": 530,
        "height": 442
      },
      "title": "Community",
      "description": "View of the exterior of the apartment complex, showcasing the building's architecture and surrounding green space.",
      "link": "false",
      "alt_text": "A building with a balcony and a white door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Apartments_Favorites%20(10).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5654bc51-d662-4d96-ae4c-de3f11cef1f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Joyce's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "118 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "Comfy small-town diner serving classic breakfast and burgers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-1361-7316-becb-13e0cab5c446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-1361-7316-becb-13e0cab5c446",
        "storage_key": "property/6767906449167197/019d0221-1361-7316-becb-13e0cab5c446.webp",
        "width": 1242,
        "height": 700
      },
      "poi_business_url": "https://m.facebook.com/Joyces-Cafe-164564046911184/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9563011336536942090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joyces-cafe",
      "poi_latitude": "48.317619",
      "poi_longitude": "-102.390838",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57ce-73bf-a226-124554581367.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57ce-73bf-a226-124554581367",
        "storage_key": "property/6767906449167197/019d0221-57ce-73bf-a226-124554581367.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJp3_7nMC8IFMRCmZRwSSktoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_4339e7be-b161-46b0-8023-67da1a123192",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "The Rustic Bean - Downtown",
      "poi_type": "Restaurants",
      "poi_address": "206 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "Cozy cafe serving gluten-free options and happy hour specials, plus panini.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-1468-74ae-b232-00d1cbb7325c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-1468-74ae-b232-00d1cbb7325c",
        "storage_key": "property/6767906449167197/019d0221-1468-74ae-b232-00d1cbb7325c.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://rusticbean.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16205611539054413618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rustic-bean---downtown",
      "poi_latitude": "48.3170326",
      "poi_longitude": "-102.3910237",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-5282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57ce-73bf-a226-124554581367.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57ce-73bf-a226-124554581367",
        "storage_key": "property/6767906449167197/019d0221-57ce-73bf-a226-124554581367.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJSXFMc2O9IFMRMkdPcdXl5eA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1e19a883-1007-4ed6-80ea-b43b3916c4d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "La Esperanza",
      "poi_type": "Restaurants",
      "poi_address": "108 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-08e2-7147-b201-0de31594155b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-08e2-7147-b201-0de31594155b",
        "storage_key": "property/6767906449167197/01a14138-08e2-7147-b201-0de31594155b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13183587807094831783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-esperanza",
      "poi_latitude": "48.3179513",
      "poi_longitude": "-102.3908029",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVD2dMS8IFMRp_oOy0KD9bY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_69035b56-e328-406b-9b62-b3703fb5b02b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Casa Fridah LLC",
      "poi_type": "Restaurants",
      "poi_address": "101 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-0489-73b3-9404-03affd3592fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0489-73b3-9404-03affd3592fd",
        "storage_key": "property/6767906449167197/01a14136-0489-73b3-9404-03affd3592fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://casafridahllcnd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7629714387488126492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-fridah-llc",
      "poi_latitude": "48.3181905",
      "poi_longitude": "-102.3901489",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-2989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVgCC9G9IFMRHLbqu88w4mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_749434a3-aa0d-4568-a640-f7ad0cd61ed3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Jimmy's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "501 12th Ave SE Apt 7, Stanley, ND 58784, USA",
      "poi_short_description": "Chain pizzeria serving traditional pies & pastas in a no-frills setting.",
      "poi_long_description": "Chain pizzeria serving traditional pies & pastas in a no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-0f73-730a-8886-904b8bccdf3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-0f73-730a-8886-904b8bccdf3e",
        "storage_key": "property/6767906449167197/01a14138-0f73-730a-8886-904b8bccdf3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://online.skytab.com/1c9883c911c9cbf81b7e4ac967fc9cfa",
      "poi_directions_map_url": "https://maps.google.com/?cid=6146525826271465084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jimmys-pizza",
      "poi_latitude": "48.307097",
      "poi_longitude": "-102.3788784",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3Mmr768IFMRfM6sXazYTFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_13fcb2bf-7182-4952-911e-ac4817ba71a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "China Express",
      "poi_type": "Restaurants",
      "poi_address": "1101 4th St SE, Stanley, ND 58784, USA",
      "poi_short_description": "Casual Chinese eatery serving tasty food with generous portions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14135-fd71-7667-a2bf-a99c667453bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-fd71-7667-a2bf-a99c667453bb",
        "storage_key": "property/6767906449167197/01a14135-fd71-7667-a2bf-a99c667453bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3938540811820354654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-express",
      "poi_latitude": "48.306870499999995",
      "poi_longitude": "-102.3832595",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYU3l8e8IFMRXkzuRQCCqDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_cbe3dd7c-956a-4c1e-9241-0e2fb8e8ed58",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Dairy Queen Grill & Chill",
      "poi_type": "Restaurants",
      "poi_address": "301 12th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_long_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-0d8f-747b-aa54-f9a510054184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-0d8f-747b-aa54-f9a510054184",
        "storage_key": "property/6767906449167197/01a14138-0d8f-747b-aa54-f9a510054184.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dairyqueen.com/en-us/locations/nd/stanley/301-12th-ave-se/15472/?utm_source=organic&utm_campaign=yext/&y_source=1_MTYyNDUzODUtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11491619529985343484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dairy-queen-grill--chill",
      "poi_latitude": "48.3073196",
      "poi_longitude": "-102.3855056",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4z_f3-9IFMR_L-3yhNvep8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1f556fae-9709-4574-af13-aba7fd70f375",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "901 Tami St, Stanley, ND 58784, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14135-f69a-732b-81c0-31a7d549f876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-f69a-732b-81c0-31a7d549f876",
        "storage_key": "property/6767906449167197/01a14135-f69a-732b-81c0-31a7d549f876.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/nd/stanley/901-tami-street?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=56184&utm_campaign=evergreen-2020&y_source=1_MTQ5MDk3NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18225443271571641904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subway",
      "poi_latitude": "48.3082673",
      "poi_longitude": "-102.3806762",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWqeC8S8IFMRMJYPzBfI7fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_45ccaefc-5528-42b3-88ea-4ff60d42178f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Pinnacle Travel Plaza of Stanley",
      "poi_type": "Shopping & Retail",
      "poi_address": "8149 US-2, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-2a58-7226-9c2f-3f29535708e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-2a58-7226-9c2f-3f29535708e1",
        "storage_key": "property/6767906449167197/019d0221-2a58-7226-9c2f-3f29535708e1.webp",
        "width": 900,
        "height": 675
      },
      "poi_business_url": "http://www.pinnaclend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11128364229863068114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-travel-plaza-of-stanley",
      "poi_latitude": "48.304912599999994",
      "poi_longitude": "-102.3851402",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-628-2921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f35-7166-8a6f-76564b7d7d3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f35-7166-8a6f-76564b7d7d3b",
        "storage_key": "property/6767906449167197/019d0221-5f35-7166-8a6f-76564b7d7d3b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ19g7Xrm8IFMR0tEmdE7kb5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_846b0d2e-395b-4f39-9b28-4492ab399c65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "The Leader",
      "poi_type": "Restaurants",
      "poi_address": "14 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "Welcoming bar and grill offering an extensive beer selection and homemade pizza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-039e-729e-9495-0afc5e1fb86f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-039e-729e-9495-0afc5e1fb86f",
        "storage_key": "property/6767906449167197/01a14136-039e-729e-9495-0afc5e1fb86f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://facebook.com/THELEADERBAR/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3929952421436843966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-leader",
      "poi_latitude": "48.318476999999994",
      "poi_longitude": "-102.3911035",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d5-765d-ba49-81234ddc4a19",
        "storage_key": "property/6767906449167197/019d0221-57d5-765d-ba49-81234ddc4a19.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTStfcS8IFMRvuftz-f-iTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_f014d0f4-e071-4141-8a1f-6c77c635c13e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "The Five Spot.",
      "poi_type": "Restaurants",
      "poi_address": "2-98 ND-8, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-0f8b-753f-b542-9b0b6868f1ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-0f8b-753f-b542-9b0b6868f1ff",
        "storage_key": "property/6767906449167197/01a14138-0f8b-753f-b542-9b0b6868f1ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://m.facebook.com/FiveSpotBarND/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3828019022595983350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-five-spot",
      "poi_latitude": "48.318702599999995",
      "poi_longitude": "-102.3903884",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d6-72c9-beba-5efdeb5b7e0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d6-72c9-beba-5efdeb5b7e0d",
        "storage_key": "property/6767906449167197/019d0221-57d6-72c9-beba-5efdeb5b7e0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSblh8S8IFMR9odF8wTbHzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_2c8045a3-83c3-486c-873d-44a7346a162c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Prairie Rose Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "112 2nd Ave NE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-0236-71aa-9480-eb696d6b053b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0236-71aa-9480-eb696d6b053b",
        "storage_key": "property/6767906449167197/01a14136-0236-71aa-9480-eb696d6b053b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4089977043413076462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-rose-golf-course",
      "poi_latitude": "48.321117",
      "poi_longitude": "-102.3895026",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-2135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63a8-7508-8b20-aac00a2d4b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63a8-7508-8b20-aac00a2d4b15",
        "storage_key": "property/6767906449167197/019d0221-63a8-7508-8b20-aac00a2d4b15.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUbTNsS8IFMR7okjjHOEwjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2851c486-e408-4ab8-9f4e-184a6bb413a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Beach Bar",
      "poi_type": "Restaurants",
      "poi_address": "114 12th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "Casual bar featuring cocktails, beer, and wine, plus bar games and sports on TV.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-13d7-70b5-a8f3-23b052b799c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-13d7-70b5-a8f3-23b052b799c3",
        "storage_key": "property/6767906449167197/01a14138-13d7-70b5-a8f3-23b052b799c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/thebeachbarstanley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15119511397589995705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beach-bar",
      "poi_latitude": "48.307434699999995",
      "poi_longitude": "-102.3884698",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d6-72c9-beba-5efdeb5b7e0d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d6-72c9-beba-5efdeb5b7e0d",
        "storage_key": "property/6767906449167197/019d0221-57d6-72c9-beba-5efdeb5b7e0d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVXm-lL68IFMRuVDSboJL09E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_be065db4-01d3-402b-9450-ffef62492bb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Cash Wise Foods Grocery Store Stanley",
      "poi_type": "Shopping & Retail",
      "poi_address": "406 Westview Ln #3047, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14135-fd17-71bb-8ea0-202fd3bc6171.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-fd17-71bb-8ea0-202fd3bc6171",
        "storage_key": "property/6767906449167197/01a14135-fd17-71bb-8ea0-202fd3bc6171.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cashwise.com/CWstore3047",
      "poi_directions_map_url": "https://maps.google.com/?cid=1757484848571250466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cash-wise-foods-grocery-store-stanley",
      "poi_latitude": "48.306102499999994",
      "poi_longitude": "-102.4002666",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5bd8-73b3-ae15-51218e424ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5bd8-73b3-ae15-51218e424ae2",
        "storage_key": "property/6767906449167197/019d0221-5bd8-73b3-ae15-51218e424ae2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP3HkWAC9IFMRInc4gSjXYxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3c536921-75db-4e2a-a23c-b1d70ce8a5a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Dakota Drug Co",
      "poi_type": "Health and Wellness",
      "poi_address": "107 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-1484-770a-bed4-174cde61f7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1484-770a-bed4-174cde61f7b4",
        "storage_key": "property/6767906449167197/01a14138-1484-770a-bed4-174cde61f7b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dakotadrugstanley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3152269501410168623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakota-drug-co",
      "poi_latitude": "48.3178841",
      "poi_longitude": "-102.3903496",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6XwnMC8IFMRL8_Z-2gcvys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5a5a69da-f670-43e6-85f2-3f357b61b884",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "702 9th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-2880-7032-bd50-b89a54ffcadb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-2880-7032-bd50-b89a54ffcadb",
        "storage_key": "property/6767906449167197/019d0221-2880-7032-bd50-b89a54ffcadb.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nd/stanley/20828",
      "poi_directions_map_url": "https://maps.google.com/?cid=8812600499405814302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "48.3084855",
      "poi_longitude": "-102.3740928",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-502-0409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5bc1-710c-b09a-f8f336a627f8",
        "storage_key": "property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmwIDegK9IFMRHnqDinalTHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_bd63ffea-33a4-44de-85b4-8e270fa15715",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "802 4th St SW, Stanley, ND 58784, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-1069-779a-ad4e-23e39e6dc525.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1069-779a-ad4e-23e39e6dc525",
        "storage_key": "property/6767906449167197/01a14138-1069-779a-ad4e-23e39e6dc525.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/nd/stanley/802-4th-st-sw?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13450077996155924981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "48.3100763",
      "poi_longitude": "-102.3975707",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-251-0653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5bc1-710c-b09a-f8f336a627f8",
        "storage_key": "property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTVROGFq9IFMR9fErCq1GqLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_f7cc2498-5755-4003-95c6-0a6814bc3b6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Holiday",
      "poi_type": "Transportation & Transit",
      "poi_address": "402 Westview Ln, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-1571-73fc-8477-05cff8be47ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1571-73fc-8477-05cff8be47ed",
        "storage_key": "property/6767906449167197/01a14138-1571-73fc-8477-05cff8be47ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18403737492075838355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holiday",
      "poi_latitude": "48.3062845",
      "poi_longitude": "-102.3986406",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-4330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5c22-71fb-8a23-2385ae815d4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5c22-71fb-8a23-2385ae815d4b",
        "storage_key": "property/6767906449167197/019d0221-5c22-71fb-8a23-2385ae815d4b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWr2EpS8IFMRk_u36r01Z_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_e4522564-973b-4813-bb83-dc6207a5d012",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Racer's",
      "poi_type": "Transportation & Transit",
      "poi_address": "321 6th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-1d1f-76b4-b49d-e2a2b4c3654b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1d1f-76b4-b49d-e2a2b4c3654b",
        "storage_key": "property/6767906449167197/01a14138-1d1f-76b4-b49d-e2a2b4c3654b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100083751902217&mibextid=ZbWKwL",
      "poi_directions_map_url": "https://maps.google.com/?cid=1472095609072970579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "racers",
      "poi_latitude": "48.3130098",
      "poi_longitude": "-102.3848247",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-3707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5c22-71fb-8a23-2385ae815d4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5c22-71fb-8a23-2385ae815d4b",
        "storage_key": "property/6767906449167197/019d0221-5c22-71fb-8a23-2385ae815d4b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7WEmce8IFMRU-s0LijvbRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_a1a9e0bd-06f1-4bb6-9b65-791ff0bbe814",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Pinnacle Express",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 12th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-2954-71b2-be3d-29dec79aee21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-2954-71b2-be3d-29dec79aee21",
        "storage_key": "property/6767906449167197/019d0221-2954-71b2-be3d-29dec79aee21.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.pinnaclend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4986061562877356703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-express",
      "poi_latitude": "48.3070038",
      "poi_longitude": "-102.3849563",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-3835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f35-7166-8a6f-76564b7d7d3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f35-7166-8a6f-76564b7d7d3b",
        "storage_key": "property/6767906449167197/019d0221-5f35-7166-8a6f-76564b7d7d3b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJV-NN-ZC9IFMRn6qI-5IMMkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_4e80285b-2f1f-40e8-b10a-9f460682372a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "702 Westview Ln, Stanley, ND 58784, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-2882-7368-b705-f8b0f7bd8ff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0221-2882-7368-b705-f8b0f7bd8ff1",
        "storage_key": "property/6767906449167197/019d0221-2882-7368-b705-f8b0f7bd8ff1.webp",
        "width": 1280,
        "height": 1029
      },
      "poi_business_url": "https://www.acehardware.com/store-details/15931",
      "poi_directions_map_url": "https://maps.google.com/?cid=12083368680609182559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-ace-hardware",
      "poi_latitude": "48.306813",
      "poi_longitude": "-102.4058099",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-628-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5bc1-710c-b09a-f8f336a627f8",
        "storage_key": "property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwcNWeMS8IFMRX3PKacu_sKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_65cd9686-d32f-4399-9144-b31eef45ae16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Prairie Home Furnishings formerly Springan Furniture",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 1st Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14135-fd81-756e-9922-9c245a010031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-fd81-756e-9922-9c245a010031",
        "storage_key": "property/6767906449167197/01a14135-fd81-756e-9922-9c245a010031.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shopphf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10325952433752416877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-home-furnishings-formerly-springan-furniture",
      "poi_latitude": "48.3181783",
      "poi_longitude": "-102.3897037",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5bc1-710c-b09a-f8f336a627f8",
        "storage_key": "property/6767906449167197/019d0221-5bc1-710c-b09a-f8f336a627f8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNXNowVy9IFMRbaJkfQcnTY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_b2a1c29d-a24e-42fa-83bd-58997f6b0608",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Junior-Senior High School",
      "poi_type": "Education",
      "poi_address": "109 8th Ave SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stanley.k12.nd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6612126963816533331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-junior-senior-high-school",
      "poi_latitude": "48.309734299999995",
      "poi_longitude": "-102.3925704",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 701-628-2342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGXTi8L-8IFMRUw0R6HD-wls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_06fe80e2-0f61-4bf9-957e-eafa96541638",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Elementary School",
      "poi_type": "Education",
      "poi_address": "118 4th Ave SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stanley.k12.nd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11969439141339854791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-elementary-school",
      "poi_latitude": "48.315526",
      "poi_longitude": "-102.393092",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_dT0tsO8IFMRx_c3dHv9G6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4b8e86a0-ec89-4ea5-a1da-0c4bf3e1d147",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Northern Plains Special Education",
      "poi_type": "Education",
      "poi_address": "109 8th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://npseu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8545257703286063288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-plains-special-education",
      "poi_latitude": "48.310483999999995",
      "poi_longitude": "-102.3893833",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 701-628-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJieAJRL-8IFMRuECJPpvalnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7f9c8640-cd09-47aa-9f2f-6ed74ff2e617",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Wee Care Learning Center",
      "poi_type": "Education",
      "poi_address": "403 1st St SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15225779556010724772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wee-care-learning-center",
      "poi_latitude": "48.3149902",
      "poi_longitude": "-102.3915769",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRVzqJu9IFMRpI1sKNbVTNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_c7ee3868-db1c-4de8-b121-4d6f6c350ba3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Little Jays Daycare",
      "poi_type": "Education",
      "poi_address": "207 2nd St SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://facebook.com/littlejaysdaycare",
      "poi_directions_map_url": "https://maps.google.com/?cid=8538631340535307699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-jays-daycare",
      "poi_latitude": "48.3170063",
      "poi_longitude": "-102.3873709",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-5297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR434PAO9IFMRs92f8PZPf3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b75b2417-3d9e-4975-b63b-88a17151a6bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Ragamuffins Ranch Daycare",
      "poi_type": "Education",
      "poi_address": "301 1st St NW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908636259241297197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ragamuffins-ranch-daycare",
      "poi_latitude": "48.323440999999995",
      "poi_longitude": "-102.3918662",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-1575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f62-743b-9797-381fb1f39d11",
        "storage_key": "property/6767906449167197/019d0221-5f62-743b-9797-381fb1f39d11.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZq1C9u8IFMRLQUGoOFCY5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5e024883-32bb-4648-b8e3-623e72a6d200",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Regis Theatre",
      "poi_type": "Entertainment",
      "poi_address": "114 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "Volunteer-operated movie house with regular showings of recent releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-36aa-73f9-ada2-6587127fa970.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-36aa-73f9-ada2-6587127fa970",
        "storage_key": "property/6767906449167197/01a14138-36aa-73f9-ada2-6587127fa970.webp",
        "width": 1280,
        "height": 766
      },
      "poi_business_url": "https://www.facebook.com/Regis-Theater-1520266858223341/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18238215093025579480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regis-theatre",
      "poi_latitude": "48.3177108",
      "poi_longitude": "-102.3907852",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f76-7128-b19d-0a22276bf2b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f76-7128-b19d-0a22276bf2b2",
        "storage_key": "property/6767906449167197/019d0221-5f76-7128-b19d-0a22276bf2b2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76nwicO8IFMR2CH1NP8nG_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_50c03971-3f90-46bc-8096-aafea7fb6b8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Sibyl Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "301 1st St SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-2c0a-7478-b37b-c271e4d8b6b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2c0a-7478-b37b-c271e4d8b6b3",
        "storage_key": "property/6767906449167197/01a14138-2c0a-7478-b37b-c271e4d8b6b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sibylcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3887444990032529606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sibyl-center-for-the-arts",
      "poi_latitude": "48.316183200000005",
      "poi_longitude": "-102.3919279",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-6434-76a4-a639-a96b0253272c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-6434-76a4-a639-a96b0253272c",
        "storage_key": "property/6767906449167197/01a14138-6434-76a4-a639-a96b0253272c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJDf-p4cO8IFMRxsjCMp_68jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_c0c4813d-a55c-40dd-8191-a1bb9f2b9a71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Flickertail Village Museum",
      "poi_type": "Entertainment",
      "poi_address": "405 12th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-2c68-75e9-a8c6-8a46196d85ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2c68-75e9-a8c6-8a46196d85ac",
        "storage_key": "property/6767906449167197/01a14138-2c68-75e9-a8c6-8a46196d85ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ndtourism.com/stanley/attractions-entertainment/family-fun/flickertail-village-museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=6283710293078511421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flickertail-village-museum",
      "poi_latitude": "48.3073458",
      "poi_longitude": "-102.3830033",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-5f95-7383-94c8-57bcd1bee726.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-5f95-7383-94c8-57bcd1bee726",
        "storage_key": "property/6767906449167197/019d0221-5f95-7383-94c8-57bcd1bee726.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ480dX4W9IFMRPQ9pEjg5NFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_60f26117-b0da-4e71-a0a3-2d2d6b9ac46c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Public Library",
      "poi_type": "Education",
      "poi_address": "116 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stanleyndlibrary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12326667465465675378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-public-library",
      "poi_latitude": "48.3176298",
      "poi_longitude": "-102.3907826",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-1553-75d1-920c-68f8269abd10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14136-1553-75d1-920c-68f8269abd10",
        "storage_key": "property/6767906449167197/01a14136-1553-75d1-920c-68f8269abd10.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ8VRencC8IFMRcj5yF8AeEas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e07c7ef6-4821-4b88-be4c-11a675834c50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Mountrail County Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "615 6th St SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-002b-713d-875d-af2f2cc4089b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-002b-713d-875d-af2f2cc4089b",
        "storage_key": "property/6767906449167197/01a14136-002b-713d-875d-af2f2cc4089b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.stanleyhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7650409438368843287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountrail-county-medical-center",
      "poi_latitude": "48.3113141",
      "poi_longitude": "-102.3801145",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63a9-72a0-afe8-a1135b751247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63a9-72a0-afe8-a1135b751247",
        "storage_key": "property/6767906449167197/019d0221-63a9-72a0-afe8-a1135b751247.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRHBaMi8IFMRF0ZFwNm2K2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_3f500266-4959-4992-a1aa-a1e96966a6ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Ina Mae Rude Aquatic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "603 8th Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-3565-73bb-8524-9dceb9364929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3565-73bb-8524-9dceb9364929",
        "storage_key": "property/6767906449167197/01a14138-3565-73bb-8524-9dceb9364929.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.stanleyhealth.org/facilities/ina-mae-rude-aquatic-center-ann-nicole-nelson-wellness-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16809894830179757322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ina-mae-rude-aquatic-center",
      "poi_latitude": "48.3105698",
      "poi_longitude": "-102.3800173",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3roiLe8IFMRCi2KEEm-SOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_15b787eb-6022-4948-826c-265fde5bba5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Boom Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "901 Tami St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.facebook.com/BoomFitnessND/?ref=aymt_homepage_panel",
      "poi_directions_map_url": "https://maps.google.com/?cid=12875624834308697916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boom-fitness",
      "poi_latitude": "48.3081761",
      "poi_longitude": "-102.3803935",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-5704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3o84bm8IFMRPO8qnpFor7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_727be74d-a05e-4558-88a2-c1c2b9f3fe4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Ray Rude Outdoor Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "536 1st St SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11526980387514232780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ray-rude-outdoor-pool",
      "poi_latitude": "48.3130436",
      "poi_longitude": "-102.3892661",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-628-2771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUq_s3C9IFMRzC-uApcP-J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_c2f7cf75-1a1d-4737-a688-e8acf6935a7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Upper Missouri District Health",
      "poi_type": "Health and Wellness",
      "poi_address": "18 2nd Ave SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.umdhu.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7260083077310340792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-missouri-district-health",
      "poi_latitude": "48.3170356",
      "poi_longitude": "-102.3894348",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-628-2951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-I7PsS8IFMRuF7o3hf_wGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6cd5bfd9-74b5-4a3f-bc7e-dbf10a1469cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Optometry Clinic, PC - Stanley",
      "poi_type": "Health and Wellness",
      "poi_address": "102 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-32aa-76aa-8d09-3590e6653bf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-32aa-76aa-8d09-3590e6653bf3",
        "storage_key": "property/6767906449167197/01a14138-32aa-76aa-8d09-3590e6653bf3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.optometryclinicpc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17438422569236558416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optometry-clinic-pc---stanley",
      "poi_latitude": "48.3182166",
      "poi_longitude": "-102.3908545",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2vpicO8IFMRUPJ_Gu-4AfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_f0a248bd-36c0-4fd4-8770-7cd1613346ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Kurtis T. Johnson, DC",
      "poi_type": "Health and Wellness",
      "poi_address": "108 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=188141405529821222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kurtis-t-johnson-dc",
      "poi_latitude": "48.3179586",
      "poi_longitude": "-102.3909228",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_xeecS8IFMRJtAljJxpnAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_f7558e02-21ab-4fce-922a-e4cb60d9f733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Mortensen Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "108 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326284737596900701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mortensen-chiropractic",
      "poi_latitude": "48.317768",
      "poi_longitude": "-102.3908462",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-7246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6xOtMe8IFMRXUU4s9rnjHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_9bf9e8f2-f754-427b-b4fb-435a95c72696",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "ROCKVIEW PHARMACY INC.",
      "poi_type": "Health and Wellness",
      "poi_address": "307 3rd Ave NE, Parshall, ND 58770, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.turtlelakedrug.com/location/rockview/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7129317996213953298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockview-pharmacy-inc",
      "poi_latitude": "47.9584171",
      "poi_longitude": "-102.1301668",
      "poi_miles_from_property": "35.2",
      "poi_walking_minutes": "12 hours 39 mins",
      "poi_biking_minutes": "2 hours 48 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 701-862-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-6439-77a4-9617-9503f87f31b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-6439-77a4-9617-9503f87f31b1",
        "storage_key": "property/6767906449167197/01a14138-6439-77a4-9617-9503f87f31b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0MP8yBRJ1MREuMh3_Fs8GI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cc71bf80-c791-46a3-ad11-b38d2145ab64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "536-606 8th Ave SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-0b7d-727d-a7e5-65e1955e35f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0b7d-727d-a7e5-65e1955e35f6",
        "storage_key": "property/6767906449167197/01a14136-0b7d-727d-a7e5-65e1955e35f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stanleynd.com/index.asp?SEC=C806D7E9-7620-4182-8F1A-9194BAB2AE64&Type=B_BASIC",
      "poi_directions_map_url": "https://maps.google.com/?cid=2451964224809759816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dog-park",
      "poi_latitude": "48.3099189",
      "poi_longitude": "-102.3961589",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 701-629-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63b0-7437-99b4-30f7d859f9db",
        "storage_key": "property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5CgN5W8IFMRSHTArXggByI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_044a8978-293d-4c85-912d-358a5bba1eca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Wilson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "533 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1164339606526191529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilson-park",
      "poi_latitude": "48.3132256",
      "poi_longitude": "-102.3896407",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63b0-7437-99b4-30f7d859f9db",
        "storage_key": "property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____0MC8IFMRqWfpBLSQKBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d4ba5e0-4988-475a-af21-63fd8ffeef7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley City Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Main St N, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-38dd-7648-9404-32d6fd1649f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-38dd-7648-9404-32d6fd1649f4",
        "storage_key": "property/6767906449167197/01a14138-38dd-7648-9404-32d6fd1649f4.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://stanleynd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6545271763758517909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-city-campground",
      "poi_latitude": "48.3214978",
      "poi_longitude": "-102.3905252",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-641d-73c2-b12b-89bfc2c38d9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-641d-73c2-b12b-89bfc2c38d9f",
        "storage_key": "property/6767906449167197/019d0221-641d-73c2-b12b-89bfc2c38d9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDah60gy9IFMRlY44pf151Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_7749284b-810a-40ab-8ed6-f3b7511ab5b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Pond Boating Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-3db5-764d-82dc-d92b06d71539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3db5-764d-82dc-d92b06d71539",
        "storage_key": "property/6767906449167197/01a14138-3db5-764d-82dc-d92b06d71539.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gf.nd.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6426277608298861577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-pond-boating-access",
      "poi_latitude": "48.320602400000006",
      "poi_longitude": "-102.3815994",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUV51zM-8IFMRCVSz1m-5Llk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7664a675-819e-4d32-956c-cb6d12d5d718",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley park north",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-0bdb-71c9-b8c5-21b8a86f6e91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0bdb-71c9-b8c5-21b8a86f6e91",
        "storage_key": "property/6767906449167197/01a14136-0bdb-71c9-b8c5-21b8a86f6e91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11237212765710572094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-park-north",
      "poi_latitude": "48.3204624",
      "poi_longitude": "-102.3911844",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63b0-7437-99b4-30f7d859f9db",
        "storage_key": "property/6767906449167197/019d0221-63b0-7437-99b4-30f7d859f9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6KGusS8IFMRPtqpHXmZ8ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7e373f04-4815-438f-8436-563dc9c77ea8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Sauber Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8th Ave SW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-3ece-76f7-9d64-bc85c0a56f14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3ece-76f7-9d64-bc85c0a56f14",
        "storage_key": "property/6767906449167197/01a14138-3ece-76f7-9d64-bc85c0a56f14.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.stanleyparkdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6044207507476483913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sauber-sports-complex",
      "poi_latitude": "48.3099284",
      "poi_longitude": "-102.4055091",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-629-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cogJMq9IFMRSY_iV7RW4VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_11d3efbd-2c88-42c7-836b-2f89cce57e42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Community Butterfly Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8101 61st St NW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-44a2-713b-b762-232e2511528c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-44a2-713b-b762-232e2511528c",
        "storage_key": "property/6767906449167197/01a14138-44a2-713b-b762-232e2511528c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8893239872527349107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-community-butterfly-garden",
      "poi_latitude": "48.29651140000001",
      "poi_longitude": "-102.3779795",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 906-396-7374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-6462-777d-905c-2a44aff4b213.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-6462-777d-905c-2a44aff4b213",
        "storage_key": "property/6767906449167197/01a14138-6462-777d-905c-2a44aff4b213.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR088H-9IFMRczVVsIsia3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_b7146a7c-cc6a-4353-b0f6-31e24c37f82d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley",
      "poi_type": "Transportation & Transit",
      "poi_address": "Main Street &, Railroad Ave, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14136-0bdd-7315-9a21-593abb28da12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0bdd-7315-9a21-593abb28da12",
        "storage_key": "property/6767906449167197/01a14136-0bdd-7315-9a21-593abb28da12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/stn",
      "poi_directions_map_url": "https://maps.google.com/?cid=2011666921268889748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley",
      "poi_latitude": "48.3199022",
      "poi_longitude": "-102.3894996",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-6774-726c-856e-3108cd66b34d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-6774-726c-856e-3108cd66b34d",
        "storage_key": "property/6767906449167197/019d0221-6774-726c-856e-3108cd66b34d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1Af5sS8IFMRlMiiGGjg6hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_bb4ff9b3-b066-48a1-b44a-8827ca9ec4a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6115 82nd Ave NW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2240919055017783519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-municipal-airport",
      "poi_latitude": "48.3015452",
      "poi_longitude": "-102.3998683",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-628-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-677c-77ef-b454-4e78980af0ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-677c-77ef-b454-4e78980af0ff",
        "storage_key": "property/6767906449167197/019d0221-677c-77ef-b454-4e78980af0ff.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xhdhfm9IFMR3zC99AFYGR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_06d8a66a-beef-4dc0-bb3d-6d24c1ad4535",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Mountrail Bethel Home",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 6th St SE, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-4eba-71a3-8c87-bb4f0a8d4b63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4eba-71a3-8c87-bb4f0a8d4b63",
        "storage_key": "property/6767906449167197/01a14138-4eba-71a3-8c87-bb4f0a8d4b63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.stanleyhealth.org/facilities/bethel-home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7261598199526731593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountrail-bethel-home",
      "poi_latitude": "48.3113336",
      "poi_longitude": "-102.3799395",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-57d7-72b2-897d-5b006348f694",
        "storage_key": "property/6767906449167197/019d0221-57d7-72b2-897d-5b006348f694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRHBaMi8IFMRSS9owBZhxmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_dbe3b0fa-90db-48d7-b728-3e096fa2a1c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Municipal Court",
      "poi_type": "Major Employers & Offices",
      "poi_address": "221 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-5303-74cc-bc28-8816b2ef474e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5303-74cc-bc28-8816b2ef474e",
        "storage_key": "property/6767906449167197/01a14138-5303-74cc-bc28-8816b2ef474e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stanleynd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14705704223528267420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-municipal-court",
      "poi_latitude": "48.3165114",
      "poi_longitude": "-102.3901339",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-6790-750c-bf61-5632e5aaa77a",
        "storage_key": "property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtyrxnMC8IFMRnC5dvxMoFcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ab994532-81e8-40a9-9855-9dafea92d79b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Mountrail County Weed Officer",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8103 61st St NW, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.co.mountrail.nd.us/pages/ag-agency-weed-control",
      "poi_directions_map_url": "https://maps.google.com/?cid=7897927869553517178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountrail-county-weed-officer",
      "poi_latitude": "48.297249699999995",
      "poi_longitude": "-102.3801327",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-628-2835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-6790-750c-bf61-5632e5aaa77a",
        "storage_key": "property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdT_qlm7IFMReiJlZo0Tm20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_f0de9e3f-f14f-4ffe-9d5e-c06e1fe991c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Bravera Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-4cdd-753c-8f0d-9fc0a4e4033f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4cdd-753c-8f0d-9fc0a4e4033f",
        "storage_key": "property/6767906449167197/01a14138-4cdd-753c-8f0d-9fc0a4e4033f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bravera.bank/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3458188044034327881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bravera-bank",
      "poi_latitude": "48.3185502",
      "poi_longitude": "-102.3902731",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-6462-777d-905c-2441c698f6ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-6462-777d-905c-2441c698f6ef",
        "storage_key": "property/6767906449167197/01a14138-6462-777d-905c-2441c698f6ef.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJcRyKnMC8IFMRSUUrK7Tz_S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_565bf142-5787-41f7-ae58-1335cc82314e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "BNC National Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "210 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-5501-739b-9507-5632ea2caf4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5501-739b-9507-5632ea2caf4f",
        "storage_key": "property/6767906449167197/01a14138-5501-739b-9507-5632ea2caf4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bnc.bank/about-us/locations-and-hours/Stanley-nd",
      "poi_directions_map_url": "https://maps.google.com/?cid=8415329611334708815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bnc-national-bank",
      "poi_latitude": "48.3168559",
      "poi_longitude": "-102.3909576",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-6462-777d-905c-2441c698f6ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-6462-777d-905c-2441c698f6ef",
        "storage_key": "property/6767906449167197/01a14138-6462-777d-905c-2441c698f6ef.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJ-at-9cO8IFMRT25u97FByXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    },
    {
      "id": "custom_e6c69a7c-6886-432f-bd8a-29709110b3ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "208 S Main St, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.stanleynd.com/index.asp?SEC=A478EA72-73BB-4990-8C22-32B3A417D449&Type=B_BASIC",
      "poi_directions_map_url": "https://maps.google.com/?cid=9502870941689375107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-police-department",
      "poi_latitude": "48.3169668",
      "poi_longitude": "-102.3911187",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-64a2-70bc-8c32-24fe52fdfc65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-64a2-70bc-8c32-24fe52fdfc65",
        "storage_key": "property/6767906449167197/01a14138-64a2-70bc-8c32-24fe52fdfc65.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9Q49sO8IFMRg-nG6cX64IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_e344675c-06ad-4c14-a20e-a28a96de35ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Stanley Fire Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "PO Box 851, Stanley, ND 58784, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-4c88-7595-a143-3276ee364263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4c88-7595-a143-3276ee364263",
        "storage_key": "property/6767906449167197/01a14138-4c88-7595-a143-3276ee364263.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6694506216508258326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-fire-department",
      "poi_latitude": "48.3174767",
      "poi_longitude": "-102.3893411",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-628-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-6790-750c-bf61-5632e5aaa77a",
        "storage_key": "property/6767906449167197/019d0221-6790-750c-bf61-5632e5aaa77a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzZoncC8IFMRFnieVe-p51w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fire_station"
    },
    {
      "id": "custom_df989816-d8ce-4df8-8f55-5bb14895489e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "custom",
      "poi_name": "Tioga Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "810 Welo St N, Tioga, ND 58852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/01a14138-524b-779d-b4af-1a6025c601c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-524b-779d-b4af-1a6025c601c6",
        "storage_key": "property/6767906449167197/01a14138-524b-779d-b4af-1a6025c601c6.webp",
        "width": 1077,
        "height": 754
      },
      "poi_business_url": "http://www.tiogahealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12191775228949798121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tioga-medical-center",
      "poi_latitude": "48.4028119",
      "poi_longitude": "-102.93513",
      "poi_miles_from_property": "28.9",
      "poi_walking_minutes": "10 hours 27 mins",
      "poi_biking_minutes": "2 hours 26 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 701-664-3305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167197/019d0221-63a9-72a0-afe8-a1135b751247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-63a9-72a0-afe8-a1135b751247",
        "storage_key": "property/6767906449167197/019d0221-63a9-72a0-afe8-a1135b751247.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8a60cRDkIFMR6Zz11vniMak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_71e4b89d4cb3270e19d3b2eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5e9fbbf3512e0616c9430b27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_be2e1fd2c44814e5557cbe69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5391bb9ee8f44a48b90494e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fd5982d6d9f7b354797bbc30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6a51bd117f02a919d1d6f790",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "rating": "5",
      "name": "Hasan AbdulJabbar",
      "text": "The apartment homes were nice and spacious. Cali was nice and informative with the tour.",
      "date": "2021-01-05",
      "title": "false"
    },
    {
      "id": "ec_e3c2a35aade4c72cc5da9b83",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "rating": "5",
      "name": "Berna Schneider",
      "text": "Next to high school. Convenient location.",
      "date": "2022-10-10",
      "title": "false"
    },
    {
      "id": "ec_40ca67ee4ac101e0e92e7135",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "rating": "5",
      "name": "Rebeca Alonzo",
      "text": "Nice place and location.",
      "date": "2022-06-16",
      "title": "false"
    },
    {
      "id": "ec_f6f87e5b26391d6cafc31190",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "rating": "5",
      "name": "George White",
      "text": "Nice staff",
      "date": "2022-08-30",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_fe8c1145f6f3c47126c3978c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "2512177",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_4c586994a657d0461d037f61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "yardi",
      "external_id": "2512176",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 50,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-e212-72dd-87c9-69bb978db3d5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Dakota Apartments Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-apartments-in-unit-laundry-stanley",
      "search_query": "apartments with in-unit laundry in stanley nd",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Stanley",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in Stanley, ND. Dakota A offers modern living with great amenities.",
      "page_copy": "Finding the perfect apartment with all the conveniences can be challenging. If you're looking for apartments with in-unit laundry in Stanley, ND, look no further than Dakota A. Located conveniently in Mountrail County, our property features a range of amenities designed to enhance your living experience.\n\nEach apartment comes complete with a washer and dryer, making laundry day hassle-free. Enjoy other features like spacious walk-in closets, a private patio or balcony, and the peace of mind that comes with on-site maintenance and professional management. Make Dakota A your next home and experience the comfort of modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Stanley, ND",
      "seo_description": "Discover Dakota A for apartments with in-unit laundry in Stanley. Enjoy amenities like spacious closets, patios, and on-site maintenance.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-central-air-conditioned-mountrail",
      "search_query": "central air conditioned apartments mountrail county",
      "category": "Amenity",
      "h1_title": "Central Air Conditioned Apartments Mountrail",
      "h2_subtitle": "Experience comfort in central air conditioned apartments in Mountrail County. Dakota A provides you with exceptional amenities and modern conveniences.",
      "page_copy": "When searching for a welcoming apartment, comfort is key. Dakota A offers central air conditioned apartments in Mountrail County that ensure you feel cozy no matter the season. Nestled in the heart of Stanley, ND, our community is perfect for those who appreciate both style and functionality.\n\nEach apartment is thoughtfully designed with features like central air conditioning, spacious walk-in closets, and private patios or balconies. From professional on-site management to timely maintenance, Dakota A stands out as an ideal home choice. Discover a luxury living experience catered to your lifestyle here.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Central Air Conditioned Apartments Mountrail",
      "seo_description": "Find central air conditioned apartments at Dakota A in Mountrail County, featuring spacious closets, patios, and on-site management.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-smoke-free-apartments-stanley",
      "search_query": "smoke free apartments stanley nd",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in Stanley, ND",
      "h2_subtitle": "Enjoy clean living in our smoke free apartments in Stanley, ND. Dakota A offers a serene and healthy environment for all its residents.",
      "page_copy": "For those prioritizing a healthy lifestyle, Dakota A provides smoke free apartments in Stanley, ND. Our community is designed for residents who value wellness and clean living. Situated in the welcoming environment of Mountrail County, you will find our complex offers more than just an excellent location.\n\nIn addition to being smoke free, each apartment includes modern amenities such as in-unit washers and dryers, spacious walk-in closets, and a private patio or balcony. With professional management and on-site maintenance ensuring everything runs smoothly, Dakota A represents the ideal choice for a comfortable and health-conscious living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments in Stanley, ND",
      "seo_description": "Dakota A offers smoke free apartments in Stanley, ND with modern amenities like walk-in closets and private patios. Ideal for health-focused living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-apartments-private-patio-balcony-stanley",
      "search_query": "apartment with private patio or balcony stanley 58784",
      "category": "Amenity",
      "h1_title": "Apartment with Private Patio or Balcony Stanley",
      "h2_subtitle": "Enjoy outdoor spaces with an apartment with a private patio or balcony in Stanley, ND 58784. Dakota A combines comfort and convenience.",
      "page_copy": "Looking for an apartment that offers an extension of living space outdoors? Dakota A provides each resident with the luxury of a private patio or balcony in Stanley, ND, ensuring you have a serene spot to unwind. Located within the 58784 area, our property is perfect for those who cherish their outdoor moments.\n\nIn addition to a private outdoor space, Dakota A features essential amenities such as in-unit washers and dryers, spacious walk-in closets, and reliable on-site maintenance. Professional management ensures the highest comfort, making Dakota A the ideal choice for individuals seeking relaxation and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Private Patio or Balcony Stanley",
      "seo_description": "Discover Dakota A, offering apartments with private patios or balconies in Stanley, 58784. Enjoy modern amenities and personal outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-spacious-walk-in-closet-apartments-nd",
      "search_query": "spacious walk-in closet apartments north dakota",
      "category": "Amenity",
      "h1_title": "Spacious Walk-In Closet Apartments North Dakota",
      "h2_subtitle": "Discover spacious walk-in closet apartments in North Dakota at Dakota A. Enjoy ample storage and modern living in a great location.",
      "page_copy": "If ample storage is a top priority, Dakota A is the perfect place for you. Offering spacious walk-in closet apartments in North Dakota, this community ensures that you have plenty of room for all your belongings. Located in the charming town of Stanley within Mountrail County, Dakota A provides a balance of modern amenities and convenient access.\n\nIn addition to the generous closet space, residents enjoy features like private patios or balconies, in-unit washers and dryers, and dedicated on-site maintenance. With professional management on hand, Dakota A is ideal for those looking for both comfort and functionality in their new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Walk-In Closet Apartments North Dakota",
      "seo_description": "Explore Dakota A in North Dakota for apartments with spacious walk-in closets, private balconies, and modern amenities. Perfect for home organization.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-two-bedroom-apartments-stanley-nd",
      "search_query": "two bedroom apartments Stanley ND",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Stanley, ND",
      "h2_subtitle": "Find spacious two bedroom apartments in Stanley, ND at Dakota A. Experience comfortable living with a range of amenities in a prime location.",
      "page_copy": "Discover the comfort of living in Dakota A's two bedroom apartments in Stanley, ND. Designed with convenience in mind, our apartments offer ample space and a cozy atmosphere, perfect for families or roommates. Located in a vibrant community within Mountrail County, Dakota A connects you with the best of Stanley.\n\nEach two-bedroom apartment comes equipped with modern amenities, including spacious walk-in closets, in-unit washers and dryers, and a private patio or balcony. With professional management and reliable on-site maintenance, Dakota A ensures that residents enjoy outstanding service and a high-quality living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Stanley, ND",
      "seo_description": "Explore Dakota A's two bedroom apartments in Stanley, ND, featuring amenities like private balconies and walk-in closets. Perfect for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-apartments-near-stanley-park-north-nd",
      "search_query": "apartments near stanley park north stanley nd",
      "category": "Park",
      "h1_title": "Apartments Near Stanley Park North, ND",
      "h2_subtitle": "Enjoy convenient living in apartments near Stanley Park North, ND. Dakota A offers comfort and prime access to local amenities.",
      "page_copy": "Located close to the serene Stanley Park in North Stanley, ND, Dakota A Apartments offer the perfect blend of convenience and relaxation. Our community provides easy access to the park, allowing residents to enjoy outdoor activities and the natural beauty of the area.\n\nDakota A is designed with residents in mind, featuring modern amenities such as spacious walk-in closets, private patios or balconies, and in-unit washers and dryers. We're committed to providing a comfortable and hassle-free living experience with on-site maintenance and professional management always available.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Stanley Park North, ND",
      "seo_description": "Dakota A offers apartments near Stanley Park North, ND, featuring patios, walk-in closets, and modern amenities. Perfect for enjoying local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167197",
      "source": "generator",
      "page_item_url": "dakota-a-pet-friendly-apartments-close-dog-park",
      "search_query": "pet-friendly apartments close to dog park mountrail county",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments Close to Dog Park",
      "h2_subtitle": "Find pet-friendly apartments close to a dog park in Mountrail County. Dakota A welcomes furry friends and offers convenient living.",
      "page_copy": "Discover pet-friendly living at Dakota A, ideally located near a dog park in Mountrail County. Our community embraces pet lovers with open arms, offering spacious layouts and pet amenities that make both you and your furry friend feel at home.\n\nDakota A combines modern convenience with a love for pets, featuring amenities like spacious walk-in closets and private outdoor spaces such as patios or balconies. Our professional management and on-site maintenance team ensure that your stay is as comfortable as possible, so you can focus on enjoying time with your pet in this beautiful locality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Dog Park Mountrail Co",
      "seo_description": "Find pet-friendly apartments near a dog park at Dakota A in Mountrail County, offering patios, walk-in closets, and a welcoming environment for pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309522449"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125691"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W3TBKRK3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4e50e677-a22f-46a8-9de9-185f95f98cd5/app.js?property=4e50e677-a22f-46a8-9de9-185f95f98cd5&propertyName=Dakota+Apartments&channelUuid=c2490ee7-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjRETTdFc3o1S2lKQzFJb0JIVFVGdGc9PSIsInZhbHVlIjoiZmhQUjBJcWhUVFhwSEM0cXcvQjVXdz09IiwibWFjIjoiNDU2MGY2YmM0ZDJmNjQxMDM3YmNmODNkMzBmNmIzYTRhNmUzNDY4M2E0M2EwM2Q3Y2U3NzYyYjBlNDY0NzRhZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309522449",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125691",
  "custom_google_gtm_id": "GTM-W3TBKRK3",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/4e50e677-a22f-46a8-9de9-185f95f98cd5/app.js?property=4e50e677-a22f-46a8-9de9-185f95f98cd5&propertyName=Dakota+Apartments&channelUuid=c2490ee7-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjRETTdFc3o1S2lKQzFJb0JIVFVGdGc9PSIsInZhbHVlIjoiZmhQUjBJcWhUVFhwSEM0cXcvQjVXdz09IiwibWFjIjoiNDU2MGY2YmM0ZDJmNjQxMDM3YmNmODNkMzBmNmIzYTRhNmUzNDY4M2E0M2EwM2Q3Y2U3NzYyYjBlNDY0NzRhZCJ9",
  "custom_audioeye_site_id": "e710f614-eb31-4bd8-9605-fe1f9aa40958",
  "custom_audioeye_site_hash": "85fbcc621d8905084134e963aae9db91"
};

export const generatedAt = '2026-11-04T23:48:36.077Z';
